import axios from '@/axios'

const actions = {
  setCategories: ({ commit, state }) => {
    if (state.categories.length) return Promise.resolve() // referência estática: busca 1x
    return axios
      .categories
      .fetch(
        '/categories'
      )
      .then((response) => {
        commit('categories', response)
      })
  },
  // Cria (ou reaproveita, se o nome já existir) e recarrega a lista, que fica em cache.
  setCreateCategory: ({ commit }, name) => {
    return axios
      .categories
      .post
      .createCategory({ name })
      .then((response) => axios.categories.fetch('/categories').then((lista) => {
        commit('categories', lista)
        return response
      }))
      .catch((error) => {
        console.log('-----------error-----------', error)
        return null
      })
  }
}

export default actions
